import { FC } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Vehicle } from "@/interface/entityInterface";
import CarLogo from "@/components/CarLogo";

interface Props {
  infoVehicle: Vehicle;
  isOpen: boolean;
  onClose: () => void;
  variables: any[];
}

const VehicleInfoDialog: FC<Props> = ({
  infoVehicle,
  isOpen,
  onClose,
  variables,
}) => {
  const getVariableByName = (name: string) => {
    const variable = variables.find((v) => v.name === name);
    return variable ? variable.value : null;
  };

  const formatOdometer = (value: string) => {
    return Math.floor(Number(value) / 10) / 100;
  };

  const formatFuel = (value: string) => {
    return Math.floor(Number(value) * 100) / 100;
  };

  const formatBattery = (value: string) => {
    const valueNumber = Number(value);
    if (valueNumber < 1) return Math.floor(valueNumber * 10000) / 100;
    return Math.floor(valueNumber * 100) / 100;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Vehicle #{infoVehicle?.id}</DialogTitle>
        </DialogHeader>

        <div>
          {/* Vehicle Basic Information */}
          <div className="bg-muted text-center ml-1 rounded-lg w-full h-[65px] pt-1 mb-2">
            <div className="flex items-center justify-center gap-2">
              <div className="w-12 h-12 bg-gray-50 border border-gray-300 rounded flex items-center justify-center">
                <CarLogo 
                  brand={infoVehicle?.make?.name || ''}
                  fallback={infoVehicle?.make?.logo}
                  size={40}
                />
              </div>
              <div>
                <p className="text-[12px] text-muted-foreground">
                  Brand & Model
                </p>
                <p>
                  {infoVehicle?.make?.name} {infoVehicle?.make_model}
                </p>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center mb-2 gap-x-2">
            <div className="bg-muted flex-1 text-center ml-1 rounded-lg w-[220px] h-[65px] pt-1">
              <p className="text-[12px] text-muted-foreground">License Plate</p>
              <p>{infoVehicle?.license_plate || "N/A"}</p>
            </div>
            <div className="bg-muted flex-1 text-center ml-1 rounded-lg w-[220px] h-[65px] pt-1">
              <p className="text-[12px] text-muted-foreground">Year</p>
              <p>{infoVehicle?.make_year || "N/A"}</p>
            </div>
          </div>

          <div className="flex justify-center items-center mb-2 gap-x-2">
            <div className="bg-muted flex-1 text-center ml-1 rounded-lg w-[220px] h-[65px] pt-1">
              <p className="text-[12px] text-muted-foreground">Nickname</p>
              <p>{infoVehicle?.nickname || "N/A"}</p>
            </div>
            <div className="bg-muted flex-1 text-center ml-1 rounded-lg w-[220px] h-[65px] pt-1">
              <p className="text-[12px] text-muted-foreground">Odometer</p>
              <p>{formatOdometer(getVariableByName("_Odometer"))} km</p>
            </div>
          </div>

          {/* GPS Data Variables */}
          <div className="flex justify-center items-center mb-2 gap-x-2">
            <div className="bg-muted flex-1 text-center ml-1 rounded-lg w-[220px] h-[65px] pt-1">
              <p className="text-[12px] text-muted-foreground">Ignition</p>
              <p>{getVariableByName("Ignition") === "True" ? "ON" : "OFF"}</p>
            </div>
            <div className="bg-muted flex-1 text-center ml-1 rounded-lg w-[220px] h-[65px] pt-1">
              <p className="text-[12px] text-muted-foreground">Voltage</p>
              <p>{getVariableByName("Voltage")} V</p>
            </div>
          </div>

          <div className="flex justify-center items-center mb-2 gap-x-2">
            {(getVariableByName("BatteryLevel") ||
              getVariableByName("Bateria_makines_elektrike")) && (
              <div className="bg-muted flex-1 text-center ml-1 rounded-lg w-[220px] h-[65px] pt-1">
                <p className="text-[12px] text-muted-foreground">
                  Battery Level
                </p>
                <p>
                  {formatBattery(
                    getVariableByName("BatteryLevel") ||
                      getVariableByName("Bateria_makines_elektrike"),
                  )}{" "}
                  %
                </p>
              </div>
            )}
            {getVariableByName("Fuel level") && (
              <div className="flex justify-center items-center mb-2 gap-x-2">
                <div className="bg-muted flex-1 text-center ml-1 rounded-lg w-[220px] h-[65px] pt-1">
                  <p className="text-[12px] text-muted-foreground">
                    Fuel Level
                  </p>
                  <p>{formatFuel(getVariableByName("Fuel level"))} %</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VehicleInfoDialog;
